import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { AMOUNT_LATEST_TRANSACTIONS } from '../../constants/general';

export const useNewDashboardDataQuery = ({
  customerId, transactionsAmount, onSuccess,
}: { customerId: string, transactionsAmount?: number, onSuccess?: (data: any) => void }) => useQuery(
  'newDashboardData',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/v1/user/${customerId}/dashboard?transactions=${transactionsAmount || AMOUNT_LATEST_TRANSACTIONS}`));
    return data;
  },
  {
    enabled: true,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    onSuccess,
  },
);
